// Admin Header Component
import React, { ReactNode } from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';
import type { IconsType } from '../../types/admin';
import CompanySelector from './CompanySelector';
import NotificationBell from '../../features/dashboard/components/NotificationBell';

interface AdminHeaderProps {
  title: string;
  subtitle?: string;
  brand: BrandConfig;
  Icons: IconsType;
  children?: ReactNode;
  showCompanySelector?: boolean;
  showNotifications?: boolean;
  rightContent?: ReactNode;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({
  title,
  subtitle,
  brand,
  Icons,
  children,
  showCompanySelector = true,
  showNotifications = true,
  rightContent,
}) => {
  return (
    <header
      className="px-6 py-4 border-b flex items-center justify-between gap-4"
      style={{
        backgroundColor: 'white',
        borderColor: brand.colors.border
      }}
    >
      <div className="shrink-0">
        <h1
          className="text-xl font-semibold"
          style={{
            color: brand.colors.secondary,
            fontFamily: brand.typography.fontFamily.heading
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm mt-0.5" style={{ color: brand.colors.textLight }}>
            {subtitle}
          </p>
        )}
      </div>

      {/* Company Selector - centered/flexible area */}
      {showCompanySelector && (
        <div className="flex-1 flex justify-center">
          <CompanySelector brand={brand} Icons={Icons} />
        </div>
      )}

      {/* Right side actions */}
      <div className="flex items-center gap-3 shrink-0">
        {/* Custom right content */}
        {rightContent}

        {/* Optional actions slot (children) */}
        {children}

        {/* Notification Bell */}
        {showNotifications && (
          <NotificationBell brand={brand} Icons={Icons} />
        )}
      </div>
    </header>
  );
};

export default AdminHeader;
